import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';

const Home: NextPage = () => {
  const currentUser = useUser();

  return (
    <CompanySelector
      user={currentUser}
      options={{
        gascaribe: {
          path: '/gascaribe',
          role: 'get_mercury_GDC',
        },
        gasguajira: {
          path: '/gasguajira',
          role: 'get_mercury_GDG',
        },
        efigas: {
          path: '/efigas',
          role: 'get_mercury_EFG',
        },
      }}
    />
  );
};

export default Home;
